import { ref } from "vue";

// Independent of API/store construction so sign-out can stop reads before any
// asynchronous secure-storage or notification cleanup starts. Token rotation
// does not change this boundary; authentication identity and tenant changes do.
export const apiSessionPaused = ref(false);
let revision = 0;
let identity = null;
let controller = new AbortController();
const listeners = new Set();

function changeSession() {
    revision += 1;
    controller.abort();
    controller = new AbortController();
    listeners.forEach((listener) => listener());
}

export function getAPISessionRevision() {
    return revision;
}

export function getAPISessionSignal() {
    return controller.signal;
}

export function pauseAPISession() {
    if (apiSessionPaused.value) return;
    apiSessionPaused.value = true;
    changeSession();
}

export function resumeAPISession(nextIdentity) {
    if (!apiSessionPaused.value && nextIdentity === identity) return;
    identity = nextIdentity;
    apiSessionPaused.value = false;
    changeSession();
}

export function invalidateAPISession() {
    changeSession();
}

export function onAPISessionChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
